var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatatableCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6001 0.599976C3.72913 0.599976 0.600098 3.72901 0.600098 7.59998C0.600098 11.4709 3.72913 14.6 7.6001 14.6C11.4711 14.6 14.6001 11.4709 14.6001 7.59998C14.6001 3.72901 11.4711 0.599976 7.6001 0.599976ZM6.61623 10.7613C6.48719 10.8903 6.3259 10.9548 6.16461 10.9548C6.00332 10.9548 5.84203 10.8903 5.713 10.7613L3.19687 8.24514L4.11623 7.32578L6.14848 9.3903L10.7614 4.77739L11.6807 5.69675L6.61623 10.7613Z",
    fill: "#6FBE46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatatableCheck);
export default __webpack_public_path__ + "static/media/datatable-check.7947e0d3071f5561d53ae72d75236d88.svg";
export { ForwardRef as ReactComponent };